// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsUserForm__wrapper__1i6cE","submitResult":"SettingsUserForm__submitResult__2cNAy","actionWrapper":"SettingsUserForm__actionWrapper__klcsJ","wrapper2faOptions":"SettingsUserForm__wrapper2faOptions__2id09","formItem":"SettingsUserForm__formItem__27dmL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsUserForm/SettingsUserForm.css
// module id = 1867
// module chunks = 0